<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <ValidationProvider class="active-form__field" name="type" rules="required|max:64" v-slot="{ errors }">
                    <label class="active-form__label active-form__label_required" for="attribute-type"
                        >Название справочника</label
                    >

                    <VInput
                        id="attribute-type"
                        name="attribute-type"
                        class="active-form__control"
                        placeholder="Название справочника"
                        :class="{
                            error: errors[0],
                        }"
                        @submit="handleSubmit(submit)"
                        v-model="attributeType"
                    ></VInput>

                    <span class="active-form__error">
                        {{ errors[0] || hiddenTypeError }}
                    </span>
                </ValidationProvider>

                <!-- attributeSearchable существовал и уходил в payload с самого начала,
                     но элемента управления под него не было — значение всегда оставалось
                     false. Из-за этого поиск по серийным номерам не находил ничего. -->
                <div class="active-form__field inventory-attribute-create-modal__searchable">
                    <label class="active-form__label" for="attribute-searchable">Участвует в поиске</label>

                    <VSwitchButton
                        id="attribute-searchable"
                        color="var(--color-green)"
                        v-model="attributeSearchable"
                    ></VSwitchButton>

                    <span class="inventory-attribute-create-modal__hint">
                        Значения этого справочника будут находиться в поиске по списку оборудования — так ищут серийные
                        и инвентарные номера.
                    </span>
                </div>

                <div class="active-form__actions">
                    <VButton type="button" class="active-form__action button_green-light" @click="hide">
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green"> Сохранить </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// svg
import TrashSvg from '@/images/trash.svg';

// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VSelect from '../../../components/VSelect/VSelect.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import VContenteditable from '../../../components/VContenteditable/VContenteditable.vue';
import VSwitchButton from '../../../components/VCheckbox/VSwitchButton.vue';

import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import InventoryAttributeValueTypes from '../../../../js/enums/InventoryAttributeValueTypes';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import { isHiddenDictionaryType } from '../../../../js/inventoryAttributes';

@Component({
    components: {
        TrashSvg,

        VInput,
        VButton,
        VSelect,
        VModalWrapper,
        VContenteditable,
        VSwitchButton,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryAttributeCreateModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_ATTRIBUTE_CREATE_CARD })
    name;
    @Prop({ type: String, default: 'Карточка создания атрибута' })
    defaultTitle;

    attributeType = '';
    attributeSearchable = false;

    valueTypes = InventoryAttributeValueTypes;

    /**
     * Название означает системное поле, справочником не являющееся (7-D3).
     */
    get isHiddenType() {
        return isHiddenDictionaryType(this.attributeType);
    }

    get hiddenTypeError() {
        if (!this.isHiddenType) {
            return '';
        }

        return 'Такой справочник не заводится: город хранится полем единицы, серийный номер — её собственное значение.';
    }

    submit() {
        // Системное имя не превращается в справочник: город и серийный номер живут
        // не значениями EAV, и заведённый под этим названием справочник стал бы вторым
        // источником того же факта. Сервер отказывает в этом независимо от формы.
        if (this.isHiddenType) {
            return;
        }

        this.resolve({
            type: this.attributeType,
            title: '',
            value: '',
            value_type: 'string',
            searchable: this.attributeSearchable,
        });
        this.hide();
    }

    beforeOpen() {
        this.attributeType = '';
        this.attributeSearchable = false;
    }
}

export default VInventoryAttributeCreateModal;
</script>
<style lang="scss">
.inventory-attribute-create-modal {
    &__searchable {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;

        & .active-form__label {
            margin: 0;
        }
    }

    &__hint {
        flex-basis: 100%;
        color: #9aa0a6;
        font-size: 0.75rem;
        line-height: 1.0625rem;
    }
}
</style>
